import { render } from "./groupList.vue?vue&type=template&id=6dc99870&scoped=true"
import script from "./groupList.vue?vue&type=script&lang=js"
export * from "./groupList.vue?vue&type=script&lang=js"

import "./groupList.vue?vue&type=style&index=0&id=6dc99870&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc99870"]])

export default __exports__